export const clearMarkers = (markers: naver.maps.Marker[]) => {
  for (const marker of markers) {
    marker.setMap(null);
  }
};
